//Prevent click/tap on navigation dropdown menu items on touch screen
if ('ontouchstart' in window) {
	$(".dropdown--parent-link").click(function (e) {
		e.preventDefault();
	});
}

/*===== LAZYLOAD IMAGES =====*/
$("img.lazyload").lazyload();

document.addEventListener("shopify:section:load", function(event) {
  $("img.lazyload").lazyload();
});


$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top + -200
    }, 1000);
});

/*===== HEADER/NAV =====*/

/* No longer used but you never know when it might be used again so I've left it
Instead we use the other code below to add a big of padding
if ( $('.site-header').hasClass('transparent') ) {
	var scrollTrigger = 0

	scrollTrigger = $('.section-hero').height()

	$(document).scroll(function() {
		if ($(document).scrollTop() >= scrollTrigger) {
			// user scrolled 50 pixels or more;
			// do stuff
			$('.site-header').removeClass('transparent')

		} else {
			$('.site-header').addClass('transparent')
		}f
	});
}*/

if ( $('.main-content').hasClass('no-padding') ) {
	//$('.main-content').css('margin-top', $('.site-header').outerHeight() )
}

/*===== PRODUCT IMAGE HOVER =====*/
function hoverImg() {
	$(".product img").hover(function() {
		if($(this).data("img2")){
			$(this).attr("src", $(this).data("img2"));
		}
	},function() {
		$(this).attr("src", $( this).data("src"));
	});
}
hoverImg();





/*===== FADE IN CONTENT ON SCROLL =====*/
// Changing the defaults
window.sr = ScrollReveal({ reset: false });
// Customizing a reveal set
sr.reveal('.fadein', { duration: 2000, scale: 1, distance: '0px',  });
sr.reveal('.fadeup', { duration: 2000, scale: 1, distance: '50px', interval:200   });
sr.reveal('.product-grid-item', { duration: 2000, scale: 1, distance: '200px', interval:200 });
sr.reveal('.featured-blocks', { duration: 1000, scale: 1, distance: '50px', interval:200 });

var nav_wrap = $('.nav-wrap').offset().top;
var announcement_height = $('.announcement-bar').outerHeight();

console.log('announcement_height:'+announcement_height)
$(window).scroll(function(e) {
	if ($(this).scrollTop() >= announcement_height) {
		$('.announcement-bar').css({'margin-top':  -Math.abs(announcement_height)+'px'});
		$('.template-index .site-header').removeClass('blurred');
	} else {
		$('.announcement-bar').css({'margin-top': '0px'});
		$('.template-index .site-header').addClass('blurred');
	}
});

/*===== VIDEOS =====*/

const playButtons = document.querySelectorAll('.video-play-button');
const pauseButtons = document.querySelectorAll('.video-pause-button');

playButtons.forEach(button => {
	button.addEventListener('click', () => {
		const videoWrap = button.closest('.section-video');
		const video = videoWrap.querySelector('video');

		if (video) {
			const videoSources = video.querySelectorAll('source');
			videoSources.forEach(source => {
				// Assuming data-src attribute exists on the video element
				source.src = source.dataset.src;
			});
			video.load();
			video.play();
		}
		button.style.display = 'none';
		video.controls = true;
	});
});

pauseButtons.forEach(button => {
	button.addEventListener('click', () => {
		const videoWrap = button.closest('.video-wrap');
		const video = videoWrap.querySelector('video');
		const videoPlay = videoWrap.querySelector('.video-play-button');
		const videoOverlay = videoWrap.querySelector('.video-overlay');

		if (video) {
			video.pause();
		}
		button.style.display = 'none';
		videoOverlay.style.display = 'flex';
	});
});

/*
$('.section-video .play').click(function(){
	$(this).parent('.section-video').find('video').trigger('play');
	$(this).parent('.section-video').find('.pause').show();
	$(this).hide();
});

$('.section-video .pause').click(function(){
	$(this).parent('.section-video').find('video').trigger('pause');
	$(this).parent('.section-video').find('.play').show();
	$(this).hide();
});

$('.section-video .sound').click(function(){
	$(this).parent('.section-video').find('video').prop('muted', false);
	$(this).parent('.section-video').find('.mute').show();
	$(this).hide();
});

$('.section-video .mute').click(function(){
	$(this).parent('.section-video').find('video').prop('muted', true);
	$(this).parent('.section-video').find('.sound').show();
	$(this).hide();
});*/

//Autoplay Videos
if ($(window).width() < 480) {
	$('.autoplay').find('video.large--hide').trigger('play');
} else {
	$('.autoplay').find('video.small--hide').trigger('play');
}

//For paused videos, display control when initially played
$('.section-video.paused .play').click(function(){
	$(this).parent('.section-video').find('.mute').show();
	$(this).removeClass('paused');
});


/*===== POPUPS =====*/

//Close popups
$(".close-popup").click(function(e) {
	$(this).closest('.popup-wrapper').fadeOut()
});

//Store Redirect
var pathname = window.location.pathname + window.location.search;
// Returns path only

function storeSelection(region) {
	setCookie("geo-location2", region, 365);

	if ( store_location == region ) {
		$('#geo-location-popup').fadeOut();
	} else {
		if ( region == 'nz' ) {
			new_url = 'https://metoday.com'
		} else {
			new_url = 'https://'+region+'.metoday.com'
		}
		//window.top.location.href = new_url + pathname.split('?')[0]
		//Just redirect to the homepage - edited 4/4/22
		window.top.location.href = new_url
	}
}

//Cookies for popup
function setCookie(cname,cvalue,exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname+"="+cvalue+"; "+expires+"; domain=.metoday.com; path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1);
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var general_viewed = getCookie("mini-popup-viewed");
var cookies_accepted = getCookie("cookies-accepted");
var newsletter_viewed = getCookie("newsletter-popup-viewed");
var customer_activity = getCookie("customer-activity");
let region = getCookie("geo-location2");

$('#general-popup .close-popup, #close-general-popup').click(function(){
	setCookie('mini-popup-viewed', 'yes', 0.03); // reset ever 40mins
	$('#general-popup').fadeOut();
});

$('.newsletter-subscribe').click(function(){
	setCookie('newsletter-popup-viewed', 'yes', 999999);
});

$('#newsletter-popup .close-popup').click(function(){
	setCookie('newsletter-popup-viewed', 'yes', hide_for);
});

if ( !Shopify.designMode ) {
	if (region != "") {
		// If customer has selected a store we might redirect
		storeSelection(region);
		//If no redirect, show the newsletter signup or cookies
		if (cookies_accepted != 'yes') {
			setTimeout(function(){
				$('#cookies-popup').fadeIn()
			}, 3000);
		} else {
			if ( (general_pop_enabled == true ) && (general_viewed != "yes") ) {
				$('#general-popup').fadeIn()
			} else {
				if (newsletter_viewed != "") {
					//Popup should be hidden
				} else {
					setTimeout(function(){
						$('#newsletter-popup').fadeIn()
					}, show_after);
				}
			}
		}
	} else {
		//Potential to display a popup but for now we'll let customer use the currency selector
		$('#geo-location-popup').fadeIn()

		var request = new XMLHttpRequest();
		request.onreadystatechange = function() {
			if (request.readyState === 4 && request.status === 200) {
				json = JSON.parse(request.responseText)

				const current_code = json['location']['country']['code']
				const language = json['location']['language']['name']
				const us_countries = 'CA US'
				let current_country = json['location']['country']['name']

				if (us_countries.indexOf(current_code) >= 0) {
					region = 'us';
					current_country = 'United States'
				} else {
					region = 'nz';
					current_country = 'New Zealand';
				}

				storeSelection(region);

			}
		};
		request.open('GET', 'https://api.ipregistry.co/?key=ira_bmkJq0l51oe9qnjDxuzsyj0xGywTzH4aDit2', true);
		request.send(null);
	}


	if ( customer_account == true ) {
		if (customer_activity == 'create') {
			//Data Tribe Analytics
			window.dataLayer = window.dataLayer || []; dataLayer.push({
				'event': 'sign_up',
				'method': 'Email'
			});
		}

		if (customer_activity == 'login') {
			//Data Tribe Analytics
			window.dataLayer = window.dataLayer || []; dataLayer.push({
				'event': 'login',
				'method': 'Email'
			});
		}
		document.cookie = 'customer-activity' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;';
	}
}
if ( getCookie("a-b-test") != "") { } else {
	random = parseInt(Math.random() * 2)
	setCookie("a-b-test", random, 1);
}

setTimeout(function() {
	if ( getCookie("a-b-test") == 0 ){
		ga('send', 'event', 'Test', 'A/B Split', 'Visitor - A', { nonInteraction: true });
	} else if ( getCookie("a-b-test") == 1 ){
		ga('send', 'event', 'Test', 'A/B Split', 'Visitor - B', { nonInteraction: true });
	}
}, 3000);

$('#accept-cookies').click(function() {
	$('#cookies-popup').fadeOut();
	setCookie("cookies-accepted", 'yes', 3000);
});

$('#wholesale-register form').submit(function() {
	setCookie("creating-account", 'yes', 1);
});

if (getCookie('creating-account') == "yes") {
	$('#account-success').fadeIn();
}

if ( getCookie("a-b-test") == 1) {
	//$('.ajax-add').show();
}

// Re-add event handler for all matching elements
$('.store-selector').on('click', function(e) {
	e.preventDefault();
	region = $(this).data('region');
	storeSelection(region);

	if (cookies_accepted != 'yes') {
		$('#cookies-popup').fadeIn();
	}
});

$('#change-store').change(function() {
	console.log('changed')
	region = $(this).val();
	storeSelection(region);
});

$('#geo-location-form .btn').click(function(){
	region = $(this).closest('form').find('select').val();
	storeSelection(region);
	$('#geo-location-popup').fadeOut();
});


/*===== HOMEPAGE SCRIPTS =====*/
if ( window.location.pathname != '/' ){
}

/*===== MOBILE SCRIPTS =====*/
if ($(window).width() < 480) {

	if (window.location.href.indexOf('/products/') > -1) {
		$('.product-description').appendTo('.mobile-container');
	}
}


$('.main-content').click(function(){
	if ( $('body').hasClass('js-drawer-open-right') ) {
		$('#CartDrawer .drawer__close button').trigger('click')
	}
});



/*===== ACCORDIONS =====*/
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}


$('#stockist-search').on('input', function() {
	var search_val = $(this).val().toLowerCase()

	$('.stockist-item').each(function() {
		if ( $(this).text().toLowerCase().indexOf(search_val) >= 0) {
			$(this).show()
		} else {
			$(this).hide()
		}
	});

	$('.accordion').addClass('active');
	$('.panel').css('max-height','3000px');
});

/*===== SEARCH =====*/


$('.search-trigger').click(function(e){
	e.preventDefault();
	$('#desktop-search').addClass('active')
	$('#search-close').addClass('active')
});

$('#search-close').click(function(){
	$('#desktop-search').removeClass('active')
	$('#search-close').removeClass('active')
});

$('#desktop-search .close').click(function(e){
	e.preventDefault();
	$('#desktop-search').removeClass('active');
	$('.search-results').slideUp();
});

$('#CartContainer').on('click', '.cart__checkout', function(e) {
	$(this).html('<span class="loader delay-2"></span><span class="loader delay-1"></span><span class="loader"></span>')
});

$('.klaviyo-signup').submit(function(e) {
	e.preventDefault();

	$(".error").remove();
	$(".success").remove();
	hasError = false

	k_form = $(this)
	k_email = $(this).find(".k_email")
	k_name = $(this).find(".k_name").val()

	k_name_val = $(this).find(".k_name").val()

	if (typeof k_name_val != "undefined") {
		k_name = k_name_val
	} else {
		k_name = ''
	}
	k_name = k_name.split(' ')

	var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	var emailaddressVal = k_email.val();

	if (emailaddressVal == '') {
		error_message = 'Please enter an email address'
		k_email.closest('.form-group').after('<p class="error">Please enter your email address.</p>');
		hasError = true;
	} else if (!emailReg.test(emailaddressVal)) {
		k_email.closest('.form-group').after('<p class="error">Enter a valid email address.</p>');
		hasError = true;
	}


	if ( hasError == false ) {
		$.ajax({
			async: true,
			crossDomain: true,
			url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
			method: "POST",
			headers: {
				"content-type": "application/x-www-form-urlencoded",
				"cache-control": "no-cache"
			},
			data: {
				g: klaviyo_list,
				$fields: "email, $first_name, $last_name, Accepts Marketing",
				$first_name: k_name[0],
				$last_name: k_name[1],
				email: k_email.val(),
				'Accepts Marketing': true
			},
			success: function(response){
				console.log(response)

				k_email.closest('.form-group').after('<p class="success">Congrats, you have succesfully signed up.</p>')

				//Data Tribe Analytics
				window.dataLayer = window.dataLayer || []; dataLayer.push({
				'event': 'generate_lead', 'lead_type': k_form.data('location')
				});
			}
		});

	}

});

/* Data Tribe Events */
$('#customer_login').submit(function(e) {
	setCookie('customer-activity', 'login', 1);
});

$('#create_customer').submit(function(e) {
	setCookie('customer-activity', 'create', 1);
});

$('.article a').click(function(e) {
	//Data Tribe Analytics
	window.dataLayer = window.dataLayer || []; dataLayer.push({
		'event': 'select_content',
		'content_type': 'Article',
		'item_name': $(this).closest('.article').data('title'),
		'item_category': $(this).closest('.article').data('category')
	});
});

$('#insta-feed').on('click', '.instafeed-overlay', function() {
	//Data Tribe Analytics
	window.dataLayer = window.dataLayer || []; dataLayer.push({
		'event': 'select_content',
		'content_type': 'Instagram',
		'item_name': $(this).closest('a').next('.instafeed-lightbox').find('.instafeed-caption').html(),
		'item_category': 'Social Media'
	});
});

$('#stamped-main-widget').on('click', '.stamped-share-links a', function() {
	//Data Tribe Analytics
	window.dataLayer = window.dataLayer || []; dataLayer.push({
		'event': 'share',
		'content_type': 'Review',
		'item_id': $(this).closest('.stamped-review').attr('id').replace('stamped-review-',''),
		'share_via': $(this).html()
	});
});

$('.product-grid-item a').click(function(e) {
	parent_obj = $(this).closest('.product-grid-item')
	//Data Tribe Analytics
	window.dataLayer = window.dataLayer || []; dataLayer.push({
		event: 'select_item',
		ecommerce: {
			items: [{
				'item_name': parent_obj.data('title'),
				'item_id': parent_obj.data('id'),
				'price': parent_obj.data('price'),
				'item_brand': 'Me | Today',
				'item_category': parent_obj.data('type'),
				'quantity': '1',
				'item_list_name': $(this).closest('.main-content').find('h1').html(),
				'index': parent_obj.data('index')
			}]
		}
	});
});

function datatribe_view_cart(){
	setTimeout(function(){
		var cart_products = []
		$('.ajaxcart__row').each(function( index ) {
			product_object = {
				"item_name": $(this).find('.ajaxcart__product-name').html(),
				"item_id": $(this).data('id'),
				"price": $(this).find('.line-price').html().replace('$',''),
				"item_brand": $(this).data('vendor'),
				"item_category": $(this).data('type'),
				"quantity": $(this).find('.ajaxcart__qty-num').val()
			}
			cart_products.push(product_object)
		});

		//Data Tribe Analytics
		window.dataLayer = window.dataLayer || []; dataLayer.push({
			event: 'view_cart',
			ecommerce: {
				items: cart_products
			}
		});
	},1000);
}

$('.site-header__cart-toggle').click(function(){
	datatribe_view_cart();
});

$('#CartDrawer').on('click', '.ajaxcart__qty--minus', function() {

	parent_obj = $(this).closest('.ajaxcart__row')

	var cart_products = []
	product_object = {
		"item_name": parent_obj.find('.ajaxcart__product-name').html(),
		"item_id": parent_obj.data('id'),
		"price": parent_obj.find('.line-price').html().replace('$',''),
		"item_brand": parent_obj.data('vendor'),
		"item_category": parent_obj.data('type'),
		"quantity": parseInt( parent_obj.find('.ajaxcart__qty-num').val() ) - 1
	}
	cart_products.push(product_object)

	//Data Tribe Analytics
	window.dataLayer = window.dataLayer || []; dataLayer.push({
		event: 'remove_from_cart',
		ecommerce: {
			items: cart_products
		}
	});
});

$('#CartDrawer').on('click', '.cart__checkout', function() {
	var cart_products = []
	$('.ajaxcart__row').each(function( index ) {
		product_object = {
			"item_name": $(this).find('.ajaxcart__product-name').html(),
			"item_id": $(this).data('id'),
			"price": $(this).find('.line-price').html().replace('$',''),
			"item_brand": $(this).data('vendor'),
			"item_category": $(this).data('type'),
			"quantity": $(this).find('.ajaxcart__qty-num').val()
		}
		cart_products.push(product_object)
	});

	//Data Tribe Analytics
	window.dataLayer = window.dataLayer || []; dataLayer.push({
		event: 'begin_checkout',
		ecommerce: {
			items: cart_products
		}
	});
});


var seen_products = []
window.addEventListener('scroll', throttle(viewport_products, 1000));

function throttle(fn, wait) {
	var time = Date.now();
	return function() {
		if ((time + wait - Date.now()) < 0) {
			fn();
			time = Date.now();
		}
	}
}

function viewport_products() {
	var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
	var top_of_screen = $(window).scrollTop();

	$('.product-grid-item').each(function(index) {
		prod_id = $(this).data('id')
		if ( !seen_products.includes( prod_id ) ) {
			top_of_element = $(this).offset().top;
			bottom_of_element = $(this).offset().top + $(this).outerHeight();

			if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
				seen_products.push(prod_id)

				//Data Tribe Analytics
				parent_obj = $(this).closest('.product-grid-item')

				var viewed_product = []
				product_object = {
					'item_name': $(this).data('title'),
					'item_id': $(this).data('id'),
					'price': $(this).data('price'),
					'item_brand': 'Me | Today',
					'item_category': $(this).data('type'),
					'quantity': '1',
					'item_list_name': $(this).closest('.main-content').find('h1').html(),
					'index': $(this).data('index')
				}
				viewed_product.push(product_object)

				window.dataLayer = window.dataLayer || []; dataLayer.push({
					event: 'view_item_list',
					ecommerce: {
						items: viewed_product
					}
				});
			}
		}
	});
}


/* We dont use ajax search because we need to include blog posts
$(function ajax_search() {

	// Current Ajax request.
	var currentAjaxRequest = null;
	// Grabbing all search forms on the page, and adding a .search-results list to each.
	var searchForms = $('#desktop-search form[action="/search"]').css('position','relative').each(function() {
		// Grabbing text input.
		var input = $(this).find('input[name="q"]');
		// Adding a list for showing search results.
		var offSet = input.innerHeight();
		$('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': offSet } ).appendTo($(this)).hide();
		// Listening to keyup and change on the text field within these search forms.
		input.attr('autocomplete', 'off').bind('keyup change', function() {
			// What's the search term?
			var term = $(this).val();
			// What's the search form?
			var form = $(this).closest('form');
			// What's the search URL?
			var searchURL = '/search?type=product&q=' + term;
			// What's the search results list?
			var resultsList = form.find('.search-results');
			// If that's a new term and it contains at least 3 characters.
			if (term.length > 2 && term != $(this).attr('data-old-term')) {
				// Saving old query.
				$(this).attr('data-old-term', term);
				// Killing any Ajax request that's currently being processed.
				if (currentAjaxRequest != null) currentAjaxRequest.abort();
				// Pulling results.
				currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
					// Reset results.
					resultsList.empty();
					// If we have no results.
					if(data.results_count == 0) {
						// resultsList.html('<li><span class="title">No results.</span></li>');
						// resultsList.fadeIn(200);
						resultsList.hide();

						//Search status messages
						$('#searching-animation').fadeOut('fast');
						$('#no-results').fadeIn('fast');
						console.log('no results');


					} else {
						// If we have results.
						//Search status messages
						$('#searching-animation').fadeOut('fast');
						$('#no-results').fadeIn('fast');
						console.log('results found');
						console.log(data.results);

						//Add a nice heading
						resultsList.append('<li class="results-heading"><h4>Top Results</h4></li>');

						var availableResults = 0

						$.each(data.results, function(index, item) {

							//console.log(item.url+' price: '+item.price_clean+'sale: '+item.compare_at_price_clean+'onsale:'+onSale);

							if ( $.isEmptyObject(item) ) {
								// If product is empty skip
								// Use this to hide soldout items:
								//( ($.isEmptyObject(item)) || (item.availability == 'soldout' ))
							} else {
								//console.log('found: '+item.title)

								var link = $('<a></a>').attr('href', item.url);
								link.append('<div class="grid__image"><img src="' + item.thumbnail + '" /></div>');
								link.append('<p class="title">' + item.title + '</p>');
								link.wrap('<li class="product-grid-item"></li>');
								resultsList.append(link.parent());

								availableResults = availableResults + 1
							}
						});

						// The Ajax request will return at the most 10 results.
						// If there are more than 10, let's link to the search results page.
						if(data.results_count > 10) {
							resultsList.append('<li class="view-all-results"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></li>');
						}
						resultsList.fadeIn(200);

						if (availableResults == 0) {
							$('.results-heading').slideUp('fast');
							$('#no-results').slideDown('fast');

						} else {
							$('.results-heading').slideDown('fast');
							$('#no-results').slideUp('fast');
						}
					}
				});
			}
		});
	});
}); */

$('body').on('click', '.ajax-add', function(e) {
	e.preventDefault();

	this_button = $(this)

	selected_variant = $(this).closest('.product-grid-item').find('select').val()

	this_button.html('<span class="loader delay-2"></span><span class="loader delay-1"></span><span class="loader"></span>')

	$.ajax({
		url: '/cart/add.js',
		dataType: 'json',
		type: 'post',
		data: {
			quantity: 1,
			id: selected_variant
		},
		success: function(itemData) {
			this_button.text('Success');
			this_button.addClass('success');
			ajaxCart.load();

			ga('send', 'event', {
				eventCategory: 'Action',
				eventAction: 'Add To Cart',
				eventLabel: 'Collection'
			});

			setTimeout(function(){
				this_button.text('Add To Cart');
				this_button.removeClass('success');
			}, 3000);
		},
		error: function(XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log("Error: " + response);
		}
	});
});

$( document ).ready(function() {
	setTimeout(function() {
		//window.scrollTo(0, 0);
}, 1000);
});

if (window.location.hash) {
	option_class = window.location.hash.replace('#','');
	$('.option').removeClass('active');
	$('.option-'+option_class).addClass('active');

	ga('send', 'event', {
		eventCategory: 'Quiz',
		eventAction: 'Click',
		eventLabel: option_class
	});

}

$('.option button').click(function(){
	$('.option').removeClass('active');

	selected_opt = $(this).data('option')
	selected_products = $(this).data('products')
	skincare_products = $(this).data('skincare')
	selected_text =  $(this).find('h5 span').text()
	//console.log()
	$('.option-'+selected_opt).addClass('active');

	$('.product-grid-item').css('opacity','1').css('transform','none');

	if (selected_text != '') {
		ga('send', 'event', {
			eventCategory: 'Quiz',
			eventAction: 'Click',
			eventLabel: $(this).find('h5 span').text()
		});
	}

	if ( selected_opt == 'supplement-products') {
		$('.product-grid-item').addClass('visually-hidden');

		$('.option-supplement-products .product-grid-item').each(function() {
			if ( selected_products.indexOf( $(this).data('handle') ) >= 0) {
				$(this).removeClass('visually-hidden');
			}
		});

		$('.option-skincare-products').addClass('active');
		$('.option-skincare-products .product-grid-item').each(function() {
			if ( skincare_products.indexOf( $(this).data('handle') ) >= 0) {
				$(this).removeClass('visually-hidden');
			}
		});

	} else {
		$('.product-grid-item').removeClass('visually-hidden');
		$('.option-skincare-products').removeClass('active');
	}
});

/* Borrowed from ajax-cart.liquid for use on product page */
validateQty = function (qty) {
	if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
		// We have a valid number!
	} else {
		// Not a number. Default to 1.
		qty = 1;
	}
	return qty;
};

// Setup listeners to add/subtract from the input
$('.js-qty__adjust').on('click', function() {
	console.log('click');
	var $el = $(this),
			id = $el.data('id'),
			$qtySelector = $el.siblings('.js-qty__num'),
			qty = parseInt($qtySelector.val().replace(/\D/g, ''));

	var qty = validateQty(qty);

	// Add or subtract from the current quantity
	if ($el.hasClass('js-qty__adjust--plus')) {
		qty += 1;
	} else {
		qty -= 1;
		if (qty <= 1) qty = 1;
	}

	// Update the input's number
	$qtySelector.val(qty);
});


// Mega menu columns:
document.querySelectorAll('.site-nav__dropdown.mega-menu').forEach((menu) => {
	const items = Array.from(menu.querySelectorAll(':scope > li'));
	if (items.length < 6) return;

	// Create mega menu columns
	const cols = Array.from({ length: 5 }, () => {
		const col = document.createElement('div');
		col.className = 'mega-col';
		return col;
	});

	// Base layout (4 cols):
	// col1: [1]
	// col2: [2,3]
	// col3: [4,5,6]
	// col4: [7] (if it exists)
	cols[0].append(items[0]);
	cols[1].append(items[1], items[2]);
	cols[2].append(items[3], items[4]);

	// item[5] is li6 in markup (image column)
	cols[2].append(items[5]);

	if (items[6]) cols[3].append(items[6]);

	// Clear and re-add columns (default: 4 columns)
	menu.innerHTML = '';
	menu.append(cols[0], cols[1], cols[2], cols[3]);


	const mq = window.matchMedia('(min-width: 1500px)');
	const apply = () => {
		menu.innerHTML = '';
		if (mq.matches) {
			// over 1500px add a 5th column:
			cols[2].contains(items[5]) && cols[2].removeChild(items[5]);
			cols[3].append(items[5]);

			menu.append(cols[0], cols[1], cols[2], cols[3]);

			if (items[6]) {
				menu.append(cols[4]);
				cols[4].append(items[6]);
			}
		} else {
			// default 4 column layout
			cols[3].contains(items[5]) && cols[3].removeChild(items[5]);
			cols[2].append(items[5]);

			// ensure li7 back in col4
			if (items[6]) cols[3].append(items[6]);

			menu.append(cols[0], cols[1], cols[2], cols[3]);
		}
	};

	apply();
	mq.addEventListener?.('change', apply);
});